import { css } from 'glamor'

const width = 130
const height = 47

export default {
  buttonWrapper: css({

  }),
  button: css({
    margin: '0 auto',
    position: 'relative',
    width: `${width}px`,
    height: `${height}px`,
    cursor: 'pointer',

    '& .hover-image': {
      display: 'none',
    },

    '&:hover .hover-image': {
      display: 'block',
    }
  }),
  image: css({
    width: `${width}px`,
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: '1',
  }),

  disabled: css({
    cursor: 'wait',
  }),

  text: css({
    zIndex: '2',
    position: 'absolute',
    left: 0,
    top: 0,
    color: 'white',
    width: `${width}px`,
    height: `${height}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: "'Press Start 2P', cursive",
  }),
}



// WEBPACK FOOTER //
// ./src/components/Button/styles.js